/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { I18nModule } from '@lm-nx-frontend/lm-inf-core';
import {
  KeyboardFocusModule,
  PaginationModule,
  TableModule,
} from '@lm-nx-frontend/lm-inf-ui';
import { CardModule } from '../card/card.module';
import { MessageModule } from '../message/message.module';
import { AssignCellComponent } from './assign-cell.component';
import { SubListComponent } from './sub-list.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    CardModule,
    TableModule,
    PaginationModule,
    MessageModule,
    KeyboardFocusModule,
  ],
  declarations: [SubListComponent, AssignCellComponent],
  exports: [SubListComponent],
})
export class SubListModule {}
